import React, { forwardRef } from 'react';
import { Box } from '@mui/material';
import ReactQuill from 'react-quill';
import '../quill-editor-fix.css';
import { FieldLabel, editorBoxSx } from './FormSection';

const CourseDescription = forwardRef(({ value, onChange, error }, ref) => (
  <Box ref={ref} sx={{ mb: 3 }}>
    <FieldLabel hint="Mínimo 80 caracteres - Máximo 400" error={error}>
      Descripción del curso
    </FieldLabel>
    <Box sx={editorBoxSx({ xs: 160, md: 180 }, error)}>
      <ReactQuill
        value={value || ''}
        onChange={onChange}
        theme="snow"
        placeholder="¿De qué trata el curso y qué aprenderá el participante?"
        style={{ flex: 1, minHeight: 0, height: '100%' }}
      />
    </Box>
  </Box>
));

export default CourseDescription;
